export const MAX_VISIBLE_ITEMS = 5;